import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/invoice_module',
    name: 'invoice_module',
    component: () => import('@/views/pages/invoice-module/InvoiceList.vue'),
    meta: {
      pageTitle: 'Invoice Module',
      breadcrumb: {
        label: 'Invoice Module'
      },
      roles: [ROLES.SUPERADMIN],
      verticalMenu: {
        title: 'Invoice Module',
        icon: 'FileTextIcon'
      }
    }
  }
];
